import React from "react";
import styled from "styled-components";
import SEO from "../seo";
import White from "../white";
import Black from "../black";
import Text from "../text";
import Portable from "../portable";
import Portable2 from "../portable2";
import ButtonWhite from "../button_white";

const Outer = styled.div`
    position: absolute;
    top: 0;
    z-index: 0;
`;

const Buttons = styled.div`
    display: flex;
    gap: 2rem;
    align-items: center;
    justify-content: space-around;
    @media (max-width: 768px) {
        flex-direction: column;
        justify-content: center;
        gap: 2rem;
        margin-top: 4rem;
        align-items: center;
        button {
            margin-top: 0 !important;
            margin-bottom: 0 !important;
        }
    }
`;

const After = styled.div`
    position: relative;
    padding-top: calc(80vh - 204px);
    z-index: 1;
    pointer-events: none;
    @media (max-width: 768px) {
        padding-top: calc(60vh - 104px);
    }
`;

const Container = styled.div`
    border: 1px solid transparent;
    width: 100vw;
    min-height: 80vh;
    background-image: url(${(props) => props.hero});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    text-align: center;
    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        padding-top: 100px;
        height: 60vh;
    }
`;

const Inner = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    color: #fff;
    margin-top: 204px;
    min-height: calc(80vh - 408px);
    z-index: 2;
    position: relative;
    button {
        border: none;
        pointer-events: all;
        z-index: 999999999;
        margin-top: 40px;
        margin-bottom: 40px;
    }
    @media (max-width: 768px) {
        min-height: 0;
        margin-top: 0;
        height: calc(60vh - 200px);
        justify-content: center;
    }
    h4 {
        font-size: 34px;
        line-height: 44px;
        font-family: Montserrat;
        font-weight: normal;
        margin-top: 30px;
        margin-bottom: 30px;
        @media (max-width: 768px) {
            font-size: 28px;
            line-height: 36px;
            margin-top: 60px;
            margin-bottom: 30px;
        }
    }
    h3 {
        font-size: 90px;
        line-height: 95px;
        font-weight: normal;
        font-family: Oswald, sans-serif;
        text-transform: uppercase;
        span {
            display: block;
            margin-top: 12px;
            font-size: 60px;
        }
        @media (max-width: 768px) {
            font-size: 50px;
            line-height: 56px;
        }
    }
`;

const IntroHeading = styled.h5`
    text-transform: uppercase;
    font-size: 22px;
    line-height: 32px;
    font-weight: normal;
    margin-bottom: 54px;
`;

const Overlay = styled.div`
    background-color: rgba(0, 0, 0, 0.55);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
`;

const Intro = ({
    title,
    subtitle,
    cta_text,
    cta_url,
    cta_text_2,
    cta_url_2,
    intro,
    intro_heading,
    intro_black,
    hero,
    url,
}) => {
    const title_bits = title.split("|");

    const first_bit = title_bits[0];
    const remaining_bits = title_bits.slice(1);

    return (
        <>
            <SEO
                title={`${title}`}
                description={subtitle}
                image={hero}
                slug={url}
            />
            <Outer>
                <Container hero={hero}>
                    <Overlay />
                    <Inner>
                        <div>
                            <h4>{subtitle}</h4>
                        </div>
                        <div>
                            <h3>
                                {title_bits[0]}
                                {remaining_bits.map((bit, index) => {
                                    return (
                                        <React.Fragment key={index}>
                                            <br />
                                            {bit}
                                        </React.Fragment>
                                    );
                                })}
                            </h3>
                        </div>
                        <Buttons>
                            {cta_text && (
                                <ButtonWhite link={cta_url}>
                                    {cta_text}
                                </ButtonWhite>
                            )}
                            {cta_text_2 && (
                                <ButtonWhite active link={cta_url_2}>
                                    {cta_text_2}
                                </ButtonWhite>
                            )}
                        </Buttons>
                        {!cta_text && <div>&nbsp;</div>}
                    </Inner>
                </Container>
            </Outer>
            <After>
                {(intro && intro_black === false) ||
                    (intro && intro_black === null && (
                        <White className="next">
                            <Text>
                                {intro_heading && (
                                    <IntroHeading>{intro_heading}</IntroHeading>
                                )}
                                <Portable2 value={intro} />
                            </Text>
                        </White>
                    ))}
                {intro && intro_black === true && (
                    <Black className="next">
                        <Text>
                            {intro_heading && (
                                <IntroHeading>{intro_heading}</IntroHeading>
                            )}
                            <Portable2 value={intro} />
                        </Text>
                    </Black>
                )}
            </After>
        </>
    );
};

export default Intro;
